<a class="skip-link" href="#main">Skip to content</a>

<social-header></social-header>

<div class="page">
    <img class="logo" [src]="'/img/logo.png' | assetsUrl">
    <main id="main" role="main">
        <router-outlet></router-outlet>
    </main>
</div>

<app-spinner *ngIf="spinner.spinning$ | async"></app-spinner>
